import { ActionNameType } from "./Type/ActionNameType";

export class BaseModel{
        ActionName:ActionNameType="CREATE"
        ApplicationId:string=""
        TenantId:string=""
}